module.exports = __webpack_public_path__ + "static/img/archivorosa-2.b7a2e02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/archivorosa-2.jpg
// module id = /jyA
// module chunks = 1